import React from 'react'
import { Row, Col, Select } from 'antd'

const Option = Select.Option

const symbols = [
  {name:'AADR', value: 'AADR'},
  {name:'ABBV', value: 'ABBV'},
  {name:'ABEOW', value: 'ABEOW'},
  {name:'ABIO', value: 'ABIO'},
  {name:'ACGLP', value: 'ACGLP'},
  {name:'ACIM', value: 'ACIM'}
]

const periods = [
  {name:'5 Years', value: '5y'},
  {name:'2 Years', value: '2y'},
  {name:'1 Years', value: '1y'},
  {name:'YTD', value: 'ytd'},
  {name:'6 Months', value: '6m'},
  {name:'3 Months', value: '3m'},
  {name:'1 Month', value: '1m'},
  {name:'1 Day', value: '1d'}
]

const indicatorList = [
  {name:'MACD', value: 'MACD'},
  {name:'EMA', value: 'EMA'}
]

const FilterRow = ({onChangeFilter, state: {symbol, period, indicators}, target}) => {

  const onChangeSymbol = (symbol) => {
    onChangeFilter({symbol})
  }

  const onChangePeriod = (period) => {
    onChangeFilter({period})
  }

  const onChangeIndicators = (indicator) => {
    if (indicators.indexOf(indicator)!==-1) {
      onChangeFilter({indicators: indicators.filter(x=>x !== indicator)})
    } else {
      onChangeFilter({indicators:[...indicators, indicator]})
    }
  }

  return (
    <Row>
      {
        !target ?
          <Col span={3}>
            <Select onChange={onChangeSymbol} value={symbol} name='symbol'>
              <Option value='' disabled>Select Symbol</Option>
                {
                    symbols.map(symbol=>(<Option key={symbol.value} value={symbol.value}>{symbol.name}</Option>))
                }
            </Select>
          </Col>
          : null
      }
      <Col span={3}>
        <Select onChange={onChangePeriod} value={period} name='period'>
          <Option value='' disabled>Select Period</Option>
          {
            periods.map(period=>(<Option key={period.value} value={period.value}>{period.name}</Option>))
          }
        </Select>
      </Col>
      <Col span={3}>
        <Select onChange={onChangeIndicators} value={''} name='indicators'>
          <Option value='' disabled>Select Indicator</Option>
          {
            indicatorList.map(indicator=>(<Option key={indicator.value} value={indicator.value}>{indicator.name}</Option>))
          }
        </Select>
      </Col>
    </Row>
  )
}

export default FilterRow



// WEBPACK FOOTER //
// ./src/components/view-chart/FilterRow.js